import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  styles: ({ theme }) => ({
    cursor: 'default',
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
      gap: '0.375rem'
    }
  })
});
